import React from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import { useCurrencySymbol } from '@/hooks/useCurrencySymbol';
import type { BudgetInputProps } from '@/lib/types';

export function CampaignBudgetInput({
  value,
  setValue,
  placeholder = '0',
  className,
  ...props
}: BudgetInputProps & React.InputHTMLAttributes<HTMLInputElement>) {
  const { symbol } = useCurrencySymbol();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const numericValue = parseFloat(inputValue);
    if (setValue) {
      setValue(!isNaN(numericValue) ? numericValue : 0);
    }
  };
  // Render 0 as empty so the "0" placeholder shows instead of a literal "0":
  // the user starts typing on a clean field (no "08", no manual delete first).
  const formattedValue = value !== undefined && !isNaN(value) && value !== 0 ? value.toString() : '';
  
  return (
    <div className='relative'>
      <div className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none z-10 font-sans'>
        {symbol}
      </div>
      <Input
        type='text'
        {...props}
        onChange={handleChange}
        value={formattedValue}
        className={cn('!ring-inset !ring-transparent budget-input pl-8 pr-4 text-right', className)}
        placeholder={placeholder}
      />
    </div>
  );
}
